app.service("DoorTypeService", ['$rootScope', function ($rootScope) {

    const modelConstructor = $rootScope.model_constructor;

    const RouteChoice = modelConstructor.RouteChoice;

    const DoorTypeModel = modelConstructor.extend(modelConstructor.RouteModel, {
        id: "door_type",
        navigation_pointer: "door_type_id",
        name: "Door Type",
        next_model_id: "site_range",
        choice_order: ['hinged', 'sliding', 'bifold']
    });

    this.factory = new modelConstructor.RouteFactory({

        choices: {
            hinged: new RouteChoice({
                name: "Hinged",
                img_src: "/img/browse/property/door-type/door-type-hinged.jpg",
                info: "Robes with hinged doors"
            }),
            sliding: new RouteChoice({
                name: "Sliding",
                img_src: "/img/browse/property/door-type/door-type-sliding.jpg",
                info: "Robes with sliding system"
            }),
            bifold: new RouteChoice({
                name: "Bi-Fold",
                img_src: "/img/browse/property/door-type/door-type-bifold.jpg",
                info: "Robes with bi-fold system"
            })
        },

        birth: function (values) {
            return new DoorTypeModel(values);
        },

        applyModelVariation: applyModelVariation
    });

    function applyModelVariation(model) {

        this.super(model);

        const variationIDs = model.variation_ids;

        const solutionID = variationIDs.solution_id;

        if (solutionID !== "bedroom_flat_pack") {
            model.choice_order = [];
        }
    }

}]);